import React, { useCallback, useEffect, useState } from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import { AD_FORMS, AD_STATUS, StatusChip, formatDate, formatMoney } from './shopConstants';

// Current and upcoming bookings of the limited ad forms (header / waiting for offers).
const BookingsPanel = ({ actions }) => {
    const [forms, setForms] = useState(null);

    const load = useCallback(async () => {
        const json = await actions.listBookings();
        if (json) setForms(json.forms);
    }, [actions.listBookings]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => { load(); }, [load]);

    if (!forms) return <div className="panel"><div className="loading">جاري التحميل...</div></div>;

    return (
        <div className="panel bookings-panel">
            <div className="panel-toolbar">
                <div className="muted">الإعلانات المحجوزة في المساحات المحدودة. الإعلان المحجوز يشغل مساحته من لحظة الشراء حتى نهاية مدته.</div>
            </div>
            {forms.map((f) => {
                const info = AD_FORMS.find((x) => x.value === f.placement);
                return (
                    <section key={f.placement} className="booking-form">
                        <header>
                            <h3>{info?.label || f.placement}</h3>
                            <div className="booking-meta">
                                <span>مستخدمة الآن: <strong>{f.usedNow} / {f.capacity}</strong></span>
                                <span><FaCalendarAlt /> أقرب موعد لإعلان شهري: <strong>{formatDate(f.nextFreeStart)}</strong></span>
                            </div>
                            <div className="booking-bar"><div style={{ width: `${Math.min(100, (f.usedNow / Math.max(1, f.capacity)) * 100)}%` }} /></div>
                        </header>
                        {f.bookings.length === 0 ? (
                            <div className="empty-state small">لا توجد حجوزات</div>
                        ) : (
                            <table className="booking-table">
                                <thead>
                                    <tr><th>الورشة</th><th>الباقة</th><th>من</th><th>إلى</th><th>المبلغ</th><th>الحالة</th></tr>
                                </thead>
                                <tbody>
                                    {f.bookings.map((b) => (
                                        <tr key={b._id}>
                                            <td>{b.shop?.logo && <img src={b.shop.logo} alt="" />} {b.shop?.name || '—'}</td>
                                            <td>{b.packageSnapshot?.name}</td>
                                            <td>{b.startsAt ? formatDate(b.startsAt) : 'عند الموافقة'}</td>
                                            <td>{b.endsAt ? formatDate(b.endsAt) : '—'}</td>
                                            <td>{formatMoney(b.pricePaid)}</td>
                                            <td><StatusChip status={b.status} map={AD_STATUS} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </section>
                );
            })}
        </div>
    );
};

export default BookingsPanel;
